var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('div',{staticStyle:{"display":"none"},attrs:{"id":"google_translate_element_global"}}),(!_vm.translatorReady)?_c('div',{staticClass:"translator-loading"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}}),_c('span',[_vm._v("Loading translator...")])],1):_vm._e(),_c('Master')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }